import { Col, Form, Input } from "antd";
import axiosInstance from "../../../api/Axios";

const checkCourseExists = async (_, value) => {
  if (!value || value.length <= 3) {
    return Promise.resolve();
  }

  try {
    const response = await axiosInstance.get(
      `/courselookup/?search=${value}&type=name`
    );
    if (response.data.exists) {
      return Promise.reject("Course name already exists");
    }
    return Promise.resolve();
  } catch (error) {
    console.error("Error checking course name:", error);
    return Promise.reject("Error checking course name");
  }
};

const checkCourseIdExists = async (_, value) => {
  if (!value || value.length <= 3) {
    return Promise.resolve();
  }

  try {
    const response = await axiosInstance.get(
      `/courselookup/?search=${value}&type=id`
    );
    if (response.data.exists) {
      return Promise.reject("Course ID already exists");
    }
    return Promise.resolve();
  } catch (error) {
    console.error("Error checking course ID:", error);
    return Promise.reject("Error checking course ID");
  }
};
const checkBundleExists = async (_, value) => {
  if (!value || value.length < 3) {
    return Promise.resolve();
  }

  try {
    const response = await axiosInstance.get(
      `/courselookup/?search=${value}&type=name`
    );
    if (response.data.exists) {
      return Promise.reject("Bundle name already exists");
    }
    return Promise.resolve();
  } catch (error) {
    console.error("Error checking Bundle name:", error);
    return Promise.reject("Error checking Bundle name");
  }
};

const checkBundleIdExists = async (_, value) => {
  if (!value || value.length <= 3) {
    return Promise.resolve();
  }

  try {
    const response = await axiosInstance.get(
      `/courselookup/?search=${value}&type=id`
    );
    if (response.data.exists) {
      return Promise.reject("Bundle ID already exists");
    }
    return Promise.resolve();
  } catch (error) {
    console.error("Error checking Bundle ID:", error);
    return Promise.reject("Error checking Bundle ID");
  }
};
export const COURSE_NAME_FIELD = {
  label: "Name",
  name: "name",
  tooltip: "Unique course identifier",
  placeholder: "Enter course name",
  span: 12,
  rules: [
    {
      required: true,
      message: "Course name is required",
    },
    {
      pattern: /^[A-Za-z0-9 _-]+$/,
      message: "Only letters, numbers, spaces, - and _ are allowed",
    },
    {
      validator: checkCourseExists,
      validateTrigger: ["onChange", "onBlur"],
    },
  ],
};

export const COURSE_ID_FIELD = {
  label: "Course ID",
  name: "course_id",
  tooltip: "Unique course identifier",
  placeholder: "Enter course ID",
  span: 8,
  rules: [
    // {
    //   required: true,
    //   message: "Course ID is required",
    // },
    {
      pattern: /^[A-Za-z0-9 _-]+$/,
      message: "Only letters, numbers, spaces, - and _ are allowed",
    },
    {
      validator: checkCourseIdExists,
      validateTrigger: ["onChange", "onBlur"],
    },
  ],
};

export const BUNDLE_NAME_FIELD = {
  label: "Bundle Name",
  name: "name",
  tooltip: "Unique Bundle identifier",
  placeholder: "Enter Bundle name",
  span: 12,
  rules: [
    {
      required: true,
      message: "Bundle name is required",
    },
    {
      pattern: /^[A-Za-z0-9 _-]+$/,
      message: "Only letters, numbers, spaces, - and _ are allowed",
    },
    {
      validator: checkBundleExists,
      validateTrigger: ["onChange", "onBlur"],
    },
  ],
};

export const BUNDLE_ID_FIELD = {
  label: "Bundle ID",
  name: "bundle_id",
  tooltip: "Unique Bundle identifier",
  placeholder: "Enter Bundle ID",
  span: 8,
  rules: [
    {
      required: true,
      message: "Bundle ID is required",
    },
    {
      pattern: /^[A-Za-z0-9 _-]+$/,
      message: "Only letters, numbers, spaces, - and _ are allowed",
    },
    {
      validator: checkBundleIdExists,
      validateTrigger: ["onChange", "onBlur"],
    },
  ],
};
export const CUSTOMER_NAME_FIELD = {
  label: "Customer Name",
  name: "name",
  tooltip: "Unique Customer identifier",
  placeholder: "Enter Customer name",
  span: 12,
  rules: [
    {
      required: true,
      message: "Customer name is required",
    },
    {
      pattern: /^[A-Za-z0-9 _-]+$/,
      message: "Only letters, numbers, spaces, - and _ are allowed",
    },
    // {
    //   validator: checkBundleExists,
    //   validateTrigger: ["onChange", "onBlur"],
    // },
  ],
};

export const CUSTOMER_ID_FIELD = {
  label: "Customer ID",
  name: "client_id",
  tooltip: "Unique Customer identifier",
  placeholder: "Enter Customer ID",
  span: 8,
  rules: [
    {
      required: true,
      message: "Customer ID is required",
    },
    {
      pattern: /^[A-Za-z0-9 _-]+$/,
      message: "Only letters, numbers, spaces, - and _ are allowed",
    },
    // {
    //   validator: checkBundleIdExists,
    //   validateTrigger: ["onChange", "onBlur"],
    // },
  ],
};
const checkCourseExistsEdit = async (_, value, initialValue, text) => {
  const type = text === "course_name" ? "name" : "id";
  const passText = text === "course_name" ? "Course name" : "Course ID";
  // If the value is the same as the initial value, resolve directly
  if (value === initialValue) {
    return Promise.resolve();
  }

  if (!value || value.length <= 3) {
    return Promise.resolve();
  }

  try {
    const response = await axiosInstance.get(
      `/courselookup/?search=${value}&type=${type}`
    );
    if (response.data.exists) {
      return Promise.reject(`${passText} already exists`);
    }
    return Promise.resolve();
  } catch (error) {
    console.error(`Error checking ${passText}:`, error);
    return Promise.reject(`Error checking ${passText}`);
  }
};

export const FormInput = ({ field }) => (
  <Col span={field.span}>
    <Form.Item
      label={field.label}
      name={field.name}
      required={field.rules.some((rule) => rule.required)}
      tooltip={field.tooltip}
      rules={field.rules}
    >
      <Input placeholder={field.placeholder} />
    </Form.Item>
  </Col>
);

export const FormInputEdit = ({ field, initialValue, text }) => (
  <Col span={field.span}>
    <Form.Item
      label={field.label}
      name={field.name}
      required={field.rules.some((rule) => rule.required)}
      tooltip={field.tooltip}
      rules={[
        {
          required: true,
          message: `${
            text === "course_name" ? "Course name" : "Course ID"
          } is required`,
        },
        {
          validator: (rule, value) =>
            checkCourseExistsEdit(rule, value, initialValue, text),
        },
      ]}
      initialValue={initialValue}
    >
      <Input placeholder={field.placeholder} />
    </Form.Item>
  </Col>
);
